import { render, staticRenderFns } from "./StoreSetting.vue?vue&type=template&id=964b6266&scoped=true"
import script from "./StoreSetting.vue?vue&type=script&lang=js"
export * from "./StoreSetting.vue?vue&type=script&lang=js"
import style0 from "./StoreSetting.vue?vue&type=style&index=0&id=964b6266&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964b6266",
  null
  
)

export default component.exports